import React, { useRef, useState } from 'react';
import { TableArrowContainer } from './styles';

const SCROLL_DIRECTON = {
  LEFT: 'left',
  RIGHT: 'right',
};

const handleTableScroll = (element, direction) => {
  let left = 240;
  if (direction === SCROLL_DIRECTON.LEFT) {
    left = -240;
  }
  element && element.scrollBy({ left: left, behavior: 'smooth' });
};

export const useTableArrow = () => {
  const [showTableArrow, setshowTableArrow] = useState(false);
  const tableScrollRef = useRef(null);

  return { showTableArrow, setshowTableArrow, tableScrollRef };
};

export const TableArrow = ({ tableScrollRef }) => {
  return (
    <TableArrowContainer>
      <span
        className="left-arrow"
        onClick={() => handleTableScroll(tableScrollRef.current, SCROLL_DIRECTON.LEFT)}
      ></span>
      <span
        className="right-arrow"
        onClick={() => handleTableScroll(tableScrollRef.current, SCROLL_DIRECTON.RIGHT)}
      ></span>
    </TableArrowContainer>
  );
};
